import { apiGet, apiPost } from "./http";

export type MemberBlacklistRow = {
  legacyId: string;
  name: string;
  phone: string;
  idNumber: string;
  reason: string;
  source: string;
  sourceLabel: string;
  sourceApplicationLegacyId?: string;
  sourceMemberLegacyId?: string;
  createdAtUtc: string;
  createdByOperatorLabel: string;
};

type BlacklistQueryResult = {
  items: MemberBlacklistRow[];
  total: number;
  page: number;
  pageSize: number;
};

export async function fetchMemberBlacklist(
  tenantLegacyId: string,
  page = 1,
  pageSize = 50,
): Promise<BlacklistQueryResult> {
  const tid = encodeURIComponent(tenantLegacyId.trim());
  const q = new URLSearchParams({
    page: String(Math.max(1, page)),
    pageSize: String(Math.min(100, Math.max(1, pageSize))),
  });
  return apiGet<BlacklistQueryResult>(`/api/tenants/${tid}/member-blacklist?${q}`);
}

export async function removeMemberBlacklistEntry(
  tenantLegacyId: string,
  entryLegacyId: string,
): Promise<void> {
  const tid = encodeURIComponent(tenantLegacyId.trim());
  const eid = encodeURIComponent(entryLegacyId.trim());
  await apiPost(`/api/tenants/${tid}/member-blacklist/${eid}/remove`, {});
}
